import { render, staticRenderFns } from "./ColumnStatus.vue?vue&type=template&id=45fd5e2b&"
import script from "./ColumnStatus.vue?vue&type=script&lang=ts&"
export * from "./ColumnStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnStatus.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports